import React, {useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDialogOpen, setViewingUserTags } from '../../../../store/Actions';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FancyButton } from '../../../common/buttons';
import { FancyTextField } from '../../../common/inputs';
import { deleteUserTag, storeUserTag, tagIsInEvents } from '../../../../firebase/Firestore';

export function EditTag(props) {
    const userTags = useSelector(state=>state.viewingUserTags);
    const dialogData = useSelector(state=>state.dialogData);
    const tag = dialogData.tag;
    const [name, setName] = useState(tag.name);
    const dispatch = useDispatch();
    const cancelEdit = () => {
        // 'View Tag' is no longer a dialog — the tag detail page lives in
        // the URL now, so just close the modal.
        if(!dialogData.parentDialog || dialogData.parentDialog === 'View Tag'){
            dispatch(setDialogOpen(''));
        } else {
            dispatch(setDialogOpen(dialogData.parentDialog, dialogData));
        }
    }

    const onSave = async ()=>{
        if(!name){
            alert('please enter a name');
            return;
        }
        const updatedTag = await saveTag();
        if(!dialogData.parentDialog || dialogData.parentDialog === 'View Tag'){
            dispatch(setDialogOpen(''));
        } else {
            dispatch(setDialogOpen(dialogData.parentDialog));
        }
        void updatedTag;
    }

    const saveTag = async () => {
        const updatedTag = await storeUserTag(tag.id, {...tag, name});
        dispatch(setViewingUserTags({...userTags, [updatedTag.id]: updatedTag}));
        return updatedTag;
    }

    const deleteTag = async() => {
        if(!window.confirm(`Are you sure you want to delete ${tag.name}?`)) return;
        if(await tagIsInEvents(tag)){
            alert('This tag exists in some of your events');
            return;
        }
        await deleteUserTag(tag.id);
        const updatedTags = {...userTags};
        delete updatedTags[tag.id];
        dispatch(setViewingUserTags(updatedTags));
        dispatch(setDialogOpen(dialogData.listDialog === null ? '' : (dialogData.listDialog || 'Tags')));
    }

    return (
        <>
            <DialogTitle>{dialogData.dialogTitle}</DialogTitle>
            <DialogContent style={{flex:1, width:'400px'}}>
                <div style={{display:'flex', flexDirection:'column'}}>
                    <FancyTextField
                        label="Name"
                        fullWidth
                        style={{marginTop:'20px'}}
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                    />
                </div>
                
            </DialogContent>
            <DialogActions style={{display:'flex', flexDirection:'row', justifyContent:'space-between', padding:'20px', paddingLeft:'24px', paddingRight:'24px'}}>
                <div>
                    {tag.id &&
                        <FancyButton variant="danger" onClick={deleteTag}>Delete</FancyButton>
                    }
                </div>
                <div style={{display:'flex', gap:'10px'}}>
                    <FancyButton onClick={cancelEdit}>Cancel</FancyButton>
                    <FancyButton variant="dark" onClick={onSave}>Save</FancyButton>
                </div>
            </DialogActions>
        </>
    );
}
